import { Link } from 'react-router-dom';
import { categories, contactInfo, navLinks, siteMeta } from '@/mocks/site';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center text-lg">
                <i className="ri-water-flash-line" />
              </span>
              <span className="font-heading font-black text-lg text-background-50">911吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-background-200/80">{siteMeta.intro}</p>
            <p className="mt-4 text-xs text-background-300/60">{contactInfo.hours}</p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-base mb-4">站内导航</h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-base mb-4">热门栏目</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/cases?category=${cat.id}`}
                    className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-base mb-4">联系与更正</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-background-200/80 hover:text-accent-400 transition-colors break-all"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-newspaper-line mt-0.5 text-accent-400" />
                <a
                  href={`mailto:${contactInfo.press}`}
                  className="text-background-200/80 hover:text-accent-400 transition-colors break-all"
                >
                  {contactInfo.press}
                </a>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100 whitespace-nowrap">
                #吃瓜不站队
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100 whitespace-nowrap">
                #只做梳理
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300/60">
          <p>© {new Date().getFullYear()} 911吃瓜 · 站内人物与事件均为创作示例，用于演示内容结构。</p>
          <p>内容仅供阅读参考，请理性围观。</p>
        </div>
      </div>
    </footer>
  );
}